var React = require('react');

function PacmanPolyclusterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M145.25 43.8412L97.0521 80.8948L89.0614 20.6278L145.25 43.8412Z","stroke":"#C99CEF","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M8.06035 103.703L28.0949 108.256L14.1339 123.33L8.06035 103.703Z","fill":"#B1F8FC","key":1}),React.createElement("path",{"d":"M150.127 152.572L148.993 175.01L130.127 162.809L150.127 152.572Z","stroke":"#C99CEF","strokeWidth":"2","key":2})]);
}

PacmanPolyclusterInline.defaultProps = {"width":"164","height":"184","viewBox":"0 0 164 184","fill":"none"};

module.exports = PacmanPolyclusterInline;

PacmanPolyclusterInline.default = PacmanPolyclusterInline;
